import {
  normalizeNutrientUnit,
  NUTRIENT_KEY_MAX_LENGTH,
  NUTRIENT_NAME_MAX_LENGTH,
  type NutrientUnit,
} from "./nutrients";
import { requireFiniteNonNegative } from "../shared/validation";

export interface DailyNutrientTarget {
  readonly nutrientKey: string;
  readonly displayName?: string;
  readonly amount: number;
  readonly unit: NutrientUnit;
}

export function createDailyNutrientTarget(target: DailyNutrientTarget): DailyNutrientTarget {
  const nutrientKey = target.nutrientKey.trim();
  if (!nutrientKey) throw new Error("Nutrient target key cannot be empty");
  if (nutrientKey.length > NUTRIENT_KEY_MAX_LENGTH) {
    throw new Error(`Nutrient target key cannot exceed ${NUTRIENT_KEY_MAX_LENGTH} characters`);
  }
  if (target.displayName !== undefined && !target.displayName.trim()) {
    throw new Error("Nutrient target display name cannot be empty");
  }
  if (target.displayName !== undefined && target.displayName.trim().length > NUTRIENT_NAME_MAX_LENGTH) {
    throw new Error(`Nutrient target display name cannot exceed ${NUTRIENT_NAME_MAX_LENGTH} characters`);
  }
  requireFiniteNonNegative(target.amount, "Nutrient target");
  return {
    nutrientKey,
    displayName: target.displayName?.trim() || undefined,
    amount: target.amount,
    unit: normalizeNutrientUnit(target.unit),
  };
}
